import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NavBarObject, MOCK} from './config';


@Component({
  selector: 'nav-bar',
  standalone: false,
  templateUrl: './nav-bar.component.html',
  styleUrls: [`./nav-bar.component.scss`]
})

export class NavBarComponent implements OnInit {
  // Entradas del componente.
  @Input() navBarItems: NavBarObject[] = MOCK;
  @Input() titulo = '';
  @Input() placeholder = '';
  @Input() initialValue: string | number;
  @Input() navOnChange = false;
  @Input() verticalLayout = false;

  // Declaración de variables
  public parentSelected;

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.navBarItems.map(item => {
      if (+item.value === +this.initialValue) {
        this.parentSelected = item;
      } else {
        item.children.map(child => {
          if (+child.value === +this.initialValue) {
            this.parentSelected = item;
          }
        });
      }
    });
  }

  public parentChange(evt) {
    this.parentSelected = evt;
    if (this.navOnChange) {
      this.router.navigate(evt.route);
    }
  }
}
